// Пункты меню My Space, которые уже заведены в admin.menu_tab (модуль OFFICE), но страниц в коде не имели
// (menu_action без ключа в PAGES — пункт никуда не вёл). Ведём их на страницы, перенесённые из старого Office.
// Ключ = menu_action существующего пункта. В PAGES подмешивается, только если такого ключа там ещё нет
// (src/constants/index.js), — своя страница с тем же ключом, когда появится, останется главнее.
const R = (code) => `/office/reports/r/${code}`;

export const pages = {
  // Отчеты
  reportSalesDepartment: R("sales-department"),
  reportDsUnaccepted: R("ds-unaccepted"),
  reportResidentDraft: R("resident-draft"),
  reportChangedMaterial: R("changed-material"),
  reportCompletedRemont: R("completed-remont"),
  reportContractorFutureCapacity: R("contractor-future-capacity"),
  reportCurrentStateWorkDuration: R("work-duration"),
  reportContractorCapacity: R("contractor-capacity"),
  reportDifferenceSmeta: R("difference-smeta"),
  reportFinanceContractor: R("finance-contractor"),
  reportProviderPayment: R("provider-payment"),
  reportClientRequestPayment: R("client-request-payment"),
  reportAktSverki: R("akt-sverki"),
  reportContractorCompletedStage: R("contractor-completed-stage"),
  reportAllRemontPayment: R("all-remont-payment"),
  reportProviderRequestInvoice: R("provider-request-invoice"),
  reportTabletopRequest: R("tabletop"),
  reportForRequestedMaterials: R("for-requested-materials"),
  reportForLogistics: R("logistics"),
  reportProviderNotShipped: R("provider-not-shipped"),
  reportRequestedMaterials: R("requested-materials"),
  reportProviderRequestsMaterials: R("provider-requests-materials"),
  reportMaterialShipmentGraph: R("material-shipment-graph"),
  reportMaterialShipping: R("material-shipping"),
  reportForOkk: R("okk"),
  reportCheckListOkk: R("check-list-okk"),
  reportStageReady: R("stage-ready"),
  reportOpenRemontDefect: R("open-remont-defect"),
  completedCheckGroupReport: R("completed-check-group"),
  reportDocsOkk: R("docs-okk"),
  reportOkkWorkload: R("okk-workload"),
  reportOkkCheckHistory: R("okk-check-history"),
  // Маркетинг
  reportNps: R("nps"),
  // Справочники
  handbookManualPlanRequests: "/office/dicts/manual-plan-requests",
  handbookServiceLinkList: "/office/dicts/service-links",
  handbookServiceTab: "/office/dicts/services",
  handbookPaymentCostsTypes: "/office/dicts/payment-costs-types",
  handbookCheckList: "/office/dicts/check-list",
  handbookFlatChoList: "/office/dicts/flats",
  handbookMaterialSetWorkList: "/office/dicts/material-set-works",
  handbookPartnerWorks: "/office/dicts/partner-works",
  handbookWorkPackContractorPrices: "/office/dicts/work-pack-contractor-prices",
  handbookWorkPackList: "/office/dicts/work-packs",
  handbookLayerEdit: "/office/dicts/layers",
  handbookParams: "/office/dicts/params",
  handbookRooms: "/office/dicts/rooms",
  // Дефекты
  handbookDefectListOkk: "/office/operations/defect/acts/1",
  handbookDefectListAcceptance: "/office/operations/defect/acts/2",
  handbookDefectBuilderLinks: "/office/operations/defect/links",
  handbookDefectCheckParams: "/office/operations/defect/checks",
};
